import { appendGaEventToAction } from "./googleAnalytics";
import { GA_EVENTS } from "../../utils/ga";

export const CREATE_NEW_STAKEHOLDER = "CREATE_NEW_STAKEHOLDER";
export const DELETE_STAKEHOLDER = "DELETE_STAKEHOLDER";

export const CHANGE_EDITABLE_STAKEHOLDER = "CHANGE_EDITABLE_STAKEHOLDER";
export const UPDATE_STAKEHOLDERS_IDS = "UPDATE_STAKEHOLDERS_IDS";
export const RESET_STAKEHOLDER_INFO = "RESET_STAKEHOLDER_INFO";

export const SET_SIGNATORY_ID = "SET_SIGNATORY_ID";

export const UPDATE_SIGNATORY = "UPDATE_SIGNATORY";

export const SET_STAKEHOLDER_STATUS_TYPE = "SET_STAKEHOLDER_STATUS_TYPE";

export const SET_IS_MULTIPLE_SIGNATORIES_JOURNEY = "SET_IS_MULTIPLE_SIGNATORIES_JOURNEY";

export const createNewStakeholder = () => {
  const action = { type: CREATE_NEW_STAKEHOLDER };
  const gaEvent = GA_EVENTS.COMPANY_STAKEHOLDER_ADD_NEW_CONTINUE;

  return appendGaEventToAction(action, gaEvent);
};

export const deleteStakeholder = stakeholderId => {
  return { type: DELETE_STAKEHOLDER, payload: stakeholderId };
};

export const changeEditableStakeholder = stakeholderId => {
  return { type: CHANGE_EDITABLE_STAKEHOLDER, payload: stakeholderId };
};

export const updateStakeholdersIds = stakeholdersIds => {
  return { type: UPDATE_STAKEHOLDERS_IDS, payload: stakeholdersIds };
};

export const resetStakeholderInfo = stakeholderIndex => {
  return { type: RESET_STAKEHOLDER_INFO, payload: stakeholderIndex };
};

export const setSelectedStakeholderId = payload => {
  return { type: SET_SIGNATORY_ID, payload };
};

export const setStakeholderStatusType = payload => {
  return { type: SET_STAKEHOLDER_STATUS_TYPE, payload };
};

export const setIsMultipleSignatoriesJourney = payload => {
  return { type: SET_IS_MULTIPLE_SIGNATORIES_JOURNEY, payload };
};
